<template>
  <div class="con">
    <div class="borders">
      <div class="one" @click="showsub">
        <div>
          <i class="iconfont icon-52"></i>
        <div>免费报价</div>
        </div>
        
        </div>
      <div class="one" @mouseenter="enter()" @mouseleave="leave()">
        <div>
   <i class="iconfont icon-erweima"></i>
        <div>关注我们</div>
        </div>
     
      </div>
      <div class="one" @click="toFreeRegistration">
        <div><i class="iconfont icon-yuyue"></i><div>马上预约</div></div>
        
        </div>
      <div class="one" @click="runtop">
        <i class="iconfont icon-top"></i>
      </div>
    </div>
  <transition name="slide-fade">
    <div class="wechaimg" v-if="wximg">
        <img src="../assets/images/WechatIMG14.jpeg">
        <div>关注桔家云</div>
    </div>
  </transition>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data(){
    return{
      show:true,
      wximg:false
    }
  },
  methods:{
    showsub(){
      this.$emit('showsp', this.show)
    },
    enter(){
      this.wximg = true
    },
    leave(){
      this.wximg = false
    },
    runtop(){
      this.$emit('runtops', 0)
    },
    toFreeRegistration(){
      this.$router.push({path:'/FreeRegistration'})
    }
  }
}
</script>
<style scoped>
.con{
  margin-right: 20px;
}
.borders{
  width: 46px;
  
  color: #fff;
}
.iconfont{
  font-size: 25px;
  color: #fff;
}
.one{
	width: 62px;
	height: 62px;
  margin-top: 5px;
	background-color: #333333;
	opacity: 0.8;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.one:hover{
  background-color: #bc001d;
}
.one:last-child{
  border-bottom: 0px;
  cursor: pointer;
}
.wechaimg{
  width: 100px;
  height: 100px;
  position: fixed;
  right: 83px;
  top: 373px;
  color: rgb(143, 141, 141);
  font-size: 12px;
}
.wechaimg img{
  width: 100%;
  height: 100%;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
